const SVG = (props: any) => {
  const width = props.width || '16'
  const height = props.height || '16'
  const color = props.color || '#7487AA'
  return (
    <svg
      width={width}
      height={height}
      style={props.style}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 10.3036L13.9167 12.9735C14.0358 13.106 14.0299 13.3087 13.9033 13.4341L13.4367 13.9013C13.3741 13.9645 13.2889 14 13.2 14C13.1111 14 13.0259 13.9645 12.9633 13.9013L10.2967 11.2314C10.2229 11.1575 10.156 11.0771 10.0967 10.9911L9.59666 10.3236C8.76937 10.9851 7.74203 11.3452 6.68333 11.3449C4.50174 11.3525 2.60601 9.84573 2.11849 7.71674C1.63096 5.58774 2.68174 3.40466 4.64873 2.45994C6.61573 1.51523 8.97398 2.06101 10.3273 3.77417C11.6807 5.48732 11.6679 7.91064 10.2967 9.60945L10.9633 10.07C11.0674 10.1367 11.1636 10.2151 11.25 10.3036ZM3.35156 6.67329C3.35156 8.51646 4.84395 10.0106 6.6849 10.0106C7.56895 10.0106 8.4168 9.65903 9.04192 9.03315C9.66704 8.40728 10.0182 7.55841 10.0182 6.67329C10.0182 4.83012 8.52584 3.33594 6.6849 3.33594C4.84395 3.33594 3.35156 4.83012 3.35156 6.67329Z"
        fill={color}
      />
    </svg>
  )
}

export default SVG
